import React from "react";
import Page from "app/Page";
import { Link, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { Intent, Classes, ProgressBar } from "@blueprintjs/core";
import { activate } from "app/auth/actions";
import { ACTIVATION } from "app/auth/constants";
import styled from "styled-components";
import Helmet from "react-helmet";
import { injectIntl, FormattedMessage } from "react-intl";
import { getLocale } from "app/utils";

const ButtonLink = styled(Link)`
  display: inline-block;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  padding: 0 10px;
  vertical-align: middle;
  font-size: 14px;
  min-width: 30px;
  min-height: 30px;
  line-height: 30px;

  text-align: center;
  text-decoration: none;
  transition: none;

  box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.4),
    inset 0 -1px 0 rgba(16, 22, 26, 0.2);
  background-color: #0f9960;
  background-image: linear-gradient(
    180deg,
    hsla(0, 0%, 100%, 0.1),
    hsla(0, 0%, 100%, 0)
  );
  color: #fff;

  &:hover {
    color: #fff;
  }
`;

const ButtonWrapper = styled.div`
  text-align: center;
`;

let Callout = ({
  children,
  intent = "success",
  iconName = "tick",
  className
}) => (
  <div
    className={`pt-callout
      ${Classes.intentClass(intent)}
      ${Classes.iconClass(iconName)}
      ${className}`}
  >
    <div className="pt-ui-text-large">{children}</div>
  </div>
);

const Token = styled.pre`
  display: inline-block;
  word-wrap: break-word;
  white-space: pre-wrap;
  width: 100%;
`;

class Check extends React.Component {
  state = { done: false };

  componentDidMount() {
    const token = this.props.match.params.token;
    const { intl } = this.props;
    this.props
      .activate({ token })
      .then(obj => {
        if (obj && obj.type === ACTIVATION.SUCCESS) {
          this.setState({ done: true });
        }
      })
      .catch(error => {
        if (error && error.type === ACTIVATION.ERROR) {
          const message = intl.formatMessage({
            id: "auth.activation.failed",
            defaultMessage: "Activation failed: {error}",
            values: { error: error.data.message }
          });
          this.setState({ error: { message } });
        } else {
          const message = intl.formatMessage({
            id: "auth.activation.error",
            defaultMessage: "Error: {error}",
            values: { error: error.message }
          });
          this.setState({ error: { message } });
        }
        throw error;
      });
  }

  render() {
    const {
      state: { error, done },
      props: {
        match: {
          params: { token }
        }
      }
    } = this;
    if (!done && !error) {
      return (
        <div>
          <ProgressBar />
        </div>
      );
    } else if (done) {
      return (
        <div>
          <Callout iconName="tick" intent={Intent.SUCCESS}>
            <FormattedMessage
              id="auth.activate.message1"
              defaultMessage="Thank you for activating your account! You can now"
            />{" "}
            <Link to={"/login" + "?" + getLocale()}>
              <FormattedMessage id="app.login" defaultMessage="Login" />
            </Link>
            }{" "}
            <FormattedMessage
              id="auth.activate.message2"
              defaultMessage="with your email address and password."
            />
          </Callout>
          <ButtonWrapper>
            <ButtonLink to="/">
              <FormattedMessage
                id="text.gotohomepage"
                defaultMessage="Go to Homepage"
              />
            </ButtonLink>
          </ButtonWrapper>
        </div>
      );
    } else if (error) {
      return (
        <div>
          <Callout iconName="error" intent={Intent.DANGER}>
            {error.message}
          </Callout>
          Token: <Token>{token}</Token>
        </div>
      );
    }
  }
}

Check = connect(
  null,
  dispatch => ({
    activate: values => dispatch(activate(values))
  })
)(Check);

const Form = props => <p>Please enter the activation token.</p>;

const page = props => {
  const { match, intl } = props;
  const title = "Activation";
  return (
    <Page className="pt-ui-text-large pt-running-text">
      <Helmet title={title} />
      <h1>{title}</h1>
      <Switch>
        <Route path={`${match.url}/:token`} intl={intl} component={Check} />
        <Route component={Form} />
      </Switch>
    </Page>
  );
};

export default injectIntl(page);



// WEBPACK FOOTER //
// ./src/app/auth/Activation.js